import {
  resolveCallToActionUrl,
  type CallToActionNavigation,
} from './resolveCallToActionUrl';

export interface ResolvedCallToAction extends CallToActionNavigation {
  id: string;
  type: string;
  labels: Record<string, string>;
}

// Structural (not imported from @libertify/experience-viewer) so this
// stays SSR-safe with no dependency on that lib — the real CallToAction
// / CallToActions types already satisfy this shape.
interface CallToActionLike {
  id: string;
  action: { type: string; url?: string | null };
  ui_definition: { labels: Record<string, string> };
}
interface CallToActionsLike {
  actions?: CallToActionLike[] | null;
}

/**
 * Resolve a publication's raw CallToActions asset into the list of CTAs
 * that actually have a navigable URL — id/type/labels plus the resolved
 * {url, target} from resolveCallToActionUrl. CTAs that can't resolve to a
 * URL (e.g. DocumentDownload with no main document) are dropped. Pure and
 * SSR-safe, shared by admin (client-side) and sales (server-side).
 */
export function resolveCallToActions(
  callToActions: CallToActionsLike | null | undefined,
  documentPath?: string | null,
): ResolvedCallToAction[] {
  return (callToActions?.actions ?? []).flatMap((cta) => {
    const nav = resolveCallToActionUrl(cta.action, documentPath);
    if (!nav) return [];
    return [
      {
        id: cta.id,
        type: cta.action.type,
        labels: cta.ui_definition.labels,
        ...nav,
      },
    ];
  });
}
